import { initTranslatedItems, parseComplexObject } from '../utils/translationProcessor';

export const CONS = {
  title: 'Already Linked | CVS Health',
  header: 'You’re already linked!',
  accessPrescription:
    'Access your prescriptions with your current account or sign in with your account that’s already linked.',
  infoText: 'Using your current account will remove prescription access from your already-linked account.',
  continue: 'Continue',
  cancelText: 'Cancel',
  chooseAcc: 'Choose your account',
  currentLabel: 'Current',
  alreadyLinkedLabel: 'Already-linked',
  yourAlreadyLinkedEmail: 'Your already linked email'
};

// Translation configuration for already-linked page
export const ALREADY_LINKED_TRANSLATION_CONFIG = [{ key: 'CONS', value: CONS, message: JSON.stringify(CONS) }];

// Helper function to process translated items
export const processAlreadyLinkedTranslations = (translatedItems: any) => {
  translatedItems = initTranslatedItems(translatedItems);

  return {
    CONS: parseComplexObject(translatedItems, CONS)
  };
};
